import React from 'react';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import Video from './Video';
import omitProps from '../../hocs/omitProps';

const enhance = compose(
  withProps(props => {
    if (props.sources) {
      return {
        children: Object.keys(props.sources).map((source, i) =>
          <source src={props.sources[source]} type={`video/${source}`} key={`source-${i}`} />
        ),
      };
    }
  }),
  omitProps(['sources'])
);

export default enhance(Video);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Video/index.js